// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NewContactView__container-bac50e {
  padding: 24px;
  height: 100%;
}

.NewContactView__form-ab520b {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.NewContactView__createButton-d9afd6 {
  display: block;
  margin-inline-start: auto;
}

.NewContactView__userNameField-d3ff7e {
  margin-bottom: 8px;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/NewContactPopup/NewContactView/NewContactView.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,YAAA;AACF;;AAEA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AACF;;AAEA;EACE,cAAA;EACA,yBAAA;AACF;;AAEA;EACE,kBAAA;AACF","sourcesContent":[".container {\n  padding: 24px;\n  height: 100%;\n}\n\n.form {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.createButton {\n  display: block;\n  margin-inline-start: auto;\n}\n\n.userNameField {\n  margin-bottom: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `NewContactView__container-bac50e`,
	"form": `NewContactView__form-ab520b`,
	"createButton": `NewContactView__createButton-d9afd6`,
	"userNameField": `NewContactView__userNameField-d3ff7e`
};
module.exports = ___CSS_LOADER_EXPORT___;
